import { AxiosInstance } from "../../../axios/axiosInstance"
import { apiRoutes } from "../../../utils/ApiRoutes"
import { IAdminAddBusinessData } from "../IApisInterface"

export const getAdminMangerDataApi = async () => {
    const response = await AxiosInstance.get(apiRoutes?.getAdminManagerData)
    return response
}

export const addAdminBusinessApi = async (payload: IAdminAddBusinessData) => {
    const response = await AxiosInstance.post(apiRoutes?.addAdminBusiness, payload)
    return response
}